export enum ChatMemberRole
{
  Creator = 1,
  Member = 2,
}
